import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import config from "../../config";
import { sumBy } from "lodash";
import { v4 as uuid } from "uuid";
import { Auth } from "aws-amplify";

const Billingcontext = React.createContext();

const init = {
  addedProducts: [],
  orderType: "Dine In",
};

const KOTBillingProvider = ({ children, ...props }) => {
  const [state, setState] = React.useState(init);
  const billLineSettings =
    useSelector((state) => state.settings.settings) || {};
  const billingPayload = useSelector((state) => state.billingPayload.data);
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const [taxList, setTaxList] = React.useState([]);
  let isTax = billLineSettings?.itemLevelTax || false;
  const dispatch = useDispatch();
  //const discount = useSelector((state) => state.billingPayload.discount);

  const itemDiscountCalc = useCallback(
    (total, discount = 0, discountType) => {
      if (billLineSettings.itemDiscount) {
        if (discount === "" || !discount) discount = 0;
        if (discountType === "flat") {
          total = parseFloat(total) - parseFloat(discount);
        }
        if (discountType === "percentage") {
          total =
            parseFloat(total) -
            (parseFloat(total) * parseFloat(discount)) / 100;
        }
      }
      return total;
    },
    [billLineSettings.itemDiscount]
  );

  const getLoyaltyValue = useCallback(() => {
    let result = 0;
    let loyalty = billingPayload.loyalty;
    if (loyalty) {
      if (loyalty === "" || Object.keys(loyalty).length === 0) {
        result = 0;
      } else {
        result = parseFloat(loyalty.minLoyaltyPointsReq);
      }
    }
    return result;
  }, [billingPayload.loyalty]);

  const getCouponValue = useCallback(() => {
    let result = 0;
    let coupon = billingPayload.coupon;
    if (coupon) {
      if (coupon === "" || !coupon || Object.keys(coupon).lenght > 0) {
        coupon = 0;
      }
      result = parseFloat(coupon?.discountAmount || 0);
    }
    return result;
  }, [billingPayload.coupon]);

  const getSubTotal = useCallback(() => {
    let total = 0;
    state?.addedProducts?.forEach((item) => {
      total += parseFloat(item.itemTotal);
    });
    return total;
  }, [state.addedProducts]);

  const taxableValueFunc = React.useCallback(
    (productPrice = 0, productTax = 0, count, taxIncExc = "inclusive") => {
      const isTax = billLineSettings.itemLevelTax || false;
      let result = 0;
      if (isTax) {
        if (taxIncExc === "inclusive") {
          result =
            (productPrice / (100 + parseInt(productTax || 0))) *
            parseFloat(count || 0) *
            100;
        } else if (taxIncExc === "exclusive") {
          result = productPrice * parseFloat(count || 0);
        } else {
          result = productPrice * count;
        }
      } else {
        result = productPrice * count;
      }
      return result;
    },
    [billLineSettings]
  );

  const taxTypeFunc = useCallback(
    (taxableValue, seletedTax) => {
      let gst = 0;
      let cess = 0;
      let igst = 0;
      let additionalcess = 0;
      const isTax = billLineSettings.itemLevelTax || false;
      if (isTax) {
        seletedTax.taxType?.forEach((tax) => {
          if (tax === "gst") {
            gst =
              gst +
              parseFloat(taxableValue * (parseInt(seletedTax.gst || 0) / 100));
          } else if (tax === "cess") {
            cess =
              cess +
              parseFloat((taxableValue * parseInt(seletedTax.cess || 0)) / 100);
          } else if (tax === "additionalcess") {
            additionalcess =
              additionalcess +
              parseFloat(
                (taxableValue * parseInt(seletedTax.additionalcess || 0)) / 100
              );
          } else if (tax === "igst") {
            igst =
              igst +
              parseFloat((taxableValue * parseInt(seletedTax.igst || 0)) / 100);
          }
        });
      }
      const itemTotal =
        parseFloat(taxableValue) +
        parseFloat(gst) +
        parseFloat(cess) +
        parseFloat(additionalcess) +
        parseFloat(igst);
      return {
        gst,
        cess,
        igst,
        additionalcess,
        itemTotal,
        taxableValue,
        totalBeforeTax: taxableValue,
      };
    },
    [billLineSettings.itemLevelTax]
  );

  const prevTaxTypeFunc = useCallback(
    (taxableValue, productTax = 0, taxType = "gst") => {
      let gst = 0;
      let cess = 0;
      let igst = 0;
      let additionalcess = 0;
      let totalPrice = 0;
      if (isTax) {
        if (taxType === "gst") {
          gst = taxableValue * (parseInt(productTax || 0) / 100);
        } else if (taxType === "cess") {
          cess = ((taxableValue * parseInt(productTax || 0)) / 100).toFixed(2);
        } else if (taxType === "additionalcess") {
          additionalcess = (taxableValue * parseInt(productTax || 0)) / 100;
        } else if (taxType === "igst") {
          igst = (taxableValue * parseInt(productTax || 0)) / 100;
        }
      }
      const total =
        parseFloat(gst) +
        parseFloat(cess) +
        parseFloat(additionalcess) +
        parseFloat(taxableValue) +
        parseFloat(igst);
      totalPrice = Math.round(total).toFixed(2);
      return {
        gst,
        cess,
        igst,
        additionalcess,
        itemTotal: totalPrice,
        taxableValue,
      };
    },
    [isTax]
  );

  const getTaxableValueAndTaxs = React.useCallback(
    (product, price = 0, quantity = 0) => {
      let selectedTax = {};
      let taxableValue = 0;
      let totalTaxPercentage = 0;
      let taxs = {};
      let newProduct = {};
      let itemTotal = 0;

      if (isTax) {
        if (
          product.taxId &&
          product.taxId !== "Select Tax" &&
          product.taxIncExc !== "Inclusive/Exclusive"
        ) {
          selectedTax = taxList.find(
            (data) => data.taxId.toString() === product.taxId.toString()
          );
          totalTaxPercentage =
            parseInt(selectedTax.gst || 0) +
            parseInt(selectedTax.cess || 0) +
            parseInt(selectedTax.additionalcess || 0) +
            parseInt(selectedTax.igst || 0);
          taxableValue = taxableValueFunc(
            price,
            totalTaxPercentage,
            quantity,
            product.taxIncExc
          );
          taxs = taxTypeFunc(taxableValue, selectedTax);
        } else {
          taxableValue = taxableValueFunc(
            price,
            product.productTax,
            quantity,
            product.taxIncExc
          );
          taxs = prevTaxTypeFunc(
            taxableValue,
            product.productTax,
            product.productTaxType
          );
        }
      } else {
        itemTotal = price * parseFloat(quantity);
      }
      itemTotal = itemDiscountCalc(
        itemTotal + (taxs.itemTotal || 0),
        product.discountPrice,
        product.discountType
      );
      newProduct = {
        ...product,
        ...taxs,
        totalTax: totalTaxPercentage,
        itemTotal: itemTotal,
      };
      return newProduct;
    },
    [
      taxList,
      taxableValueFunc,
      taxTypeFunc,
      isTax,
      itemDiscountCalc,
      prevTaxTypeFunc,
    ]
  );

  const removeProductFromBilling = React.useCallback((productId) => {
    setState((state) => {
      return {
        ...state,
        addedProducts: state.addedProducts.filter(
          (item) => item.productId !== productId
        ),
      };
    });
  }, []);

  const updateProductPriceFromProduct = React.useCallback(
    (product, price = 0) => {
      let newProducts = getTaxableValueAndTaxs(product, price, product.count);
      setState((state) => {
        return {
          ...state,
          addedProducts: state.addedProducts.map((item) => {
            if (item.productId === product.productId) {
              // item.productPrice = price;
              return {
                ...newProducts,
                productPrice: price,
              };
            }
            return item;
          }),
        };
      });
    },
    [getTaxableValueAndTaxs]
  );

  const getDiscountValue = useCallback(() => {
    let discount = 0;
    const subTotal = getSubTotal();
    const type = billingPayload.discountType;
    const value = billingPayload.discount || 0;
    if (type === "flat") {
      discount = parseFloat(value);
    } else if (type === "percentage") {
      discount = (parseFloat(subTotal) * parseFloat(value)) / 100;
    }
    return discount;
  }, [getSubTotal, billingPayload.discountType, billingPayload.discount]);

  const updateProductQuantityFromProduct = React.useCallback(
    (product, quantity = 0) => {
      let newProducts = getTaxableValueAndTaxs(
        product,
        product.productPrice,
        quantity
      );
      // let selectedTax = {};
      // let taxableValue = 0;
      // let totalTaxPercentage = 0;
      // let taxs = {};
      // if (product.taxId) {
      //   selectedTax = taxList.find(
      //     (data) => data.taxId.toString() === product.taxId.toString()
      //   );
      //   totalTaxPercentage =
      //     parseInt(selectedTax.gst || 0) +
      //     parseInt(selectedTax.cess || 0) +
      //     parseInt(selectedTax.additionalcess || 0) +
      //     parseInt(selectedTax.igst || 0);
      //   taxableValue = taxableValueFunc(
      //     product.productPrice,
      //     totalTaxPercentage,
      //     quantity,
      //     product.taxIncExc
      //   );
      //   taxs = taxTypeFunc(taxableValue, selectedTax);
      // }
      setState((state) => {
        return {
          ...state,
          addedProducts: state.addedProducts.map((item, index) => {
            if (item.productId === product.productId) {
              return {
                ...newProducts,
                count: quantity,
              };
            }
            return item;
          }),
        };
      });
    },
    [getTaxableValueAndTaxs]
  );

  const updateQuantityForProduct = React.useCallback((product, quantity) => {
    setState((state) => {
      return {
        ...state,
        products: state.products.map((item) => {
          if (item.product.productId === product.productId) {
            return {
              ...item,
              product: {
                ...item.product,
                quantity,
              },
            };
          }
          return item;
        }),
      };
    });
  }, []);

  const updateExistingProductQuantity = React.useCallback(
    (product) => {
      const quantity = parseFloat(product.count) + 1;
      const newProduct = getTaxableValueAndTaxs(
        product,
        product.productPrice,
        quantity
      );
      setState((state) => {
        return {
          ...state,
          addedProducts: state.addedProducts.map((item) => {
            if (item.productId === product.productId) {
              return {
                ...item,
                ...newProduct,
                count: quantity,
              };
            }
            return item;
          }),
        };
      });
    },
    [getTaxableValueAndTaxs]
  );

  const addProductToBilling = React.useCallback(
    (product) => {
      const checkAlreadyExist = state.addedProducts.find(
        (item) => item.productId === product.productId
      );
      if (checkAlreadyExist) {
        updateExistingProductQuantity(product);
      } else {
        let newProducts = getTaxableValueAndTaxs(
          product,
          product.productPrice,
          product.count
        );
        setState((state) => {
          return {
            ...state,
            addedProducts: [newProducts, ...state.addedProducts],
          };
        });
      }
    },
    [getTaxableValueAndTaxs, state.addedProducts, updateExistingProductQuantity]
  );

  const getOtherCharges = () => {
    let otherCharges = billLineSettings.otherChargesField;
    const result = sumBy(otherCharges, (o) => parseInt(o.price || 0));
    return result;
  };

  const getTotalAmount = useCallback(() => {
    const discount = getDiscountValue();
    const coupon = getCouponValue();
    const totalDiscountValue = discount + coupon;
    let totalAmount = 0;
    const otherCharges = billLineSettings.otherChargesField;
    const sumOtherCharges = sumBy(otherCharges, (o) => parseInt(o.price || 0));
    state.addedProducts.forEach((item) => {
      totalAmount += parseFloat(item.itemTotal);
    });
    return totalAmount > 0
      ? totalAmount + sumOtherCharges - totalDiscountValue
      : 0;
  }, [
    billLineSettings.otherChargesField,
    state.addedProducts,
    getDiscountValue,
    getLoyaltyValue,
    getCouponValue,
  ]);

  const clearAll = useCallback(() => {
    setState(init);
    dispatch({
      type: "CLEAR_ALL_BILLING_PAYLOAD",
    });
  }, [dispatch]);

  const value = React.useMemo(() => {
    return {
      state,
      setState,
      taxList,
      addProductToBilling,
      removeProductFromBilling,
      updateQuantityForProduct,
      updateProductPriceFromProduct,
      updateProductQuantityFromProduct,
      updateExistingProductQuantity,
      getLoyaltyValue,
      getTotalAmount,
      getSubTotal,
      clearAll,
      getCouponValue,
      getDiscountValue,
    };
  }, [
    taxList,
    getTotalAmount,
    setState,
    addProductToBilling,
    removeProductFromBilling,
    updateQuantityForProduct,
    updateProductPriceFromProduct,
    updateProductQuantityFromProduct,
    updateExistingProductQuantity,
    getLoyaltyValue,
    getCouponValue,
    getDiscountValue,
    state,
    getSubTotal,
    clearAll,
  ]);

  React.useEffect(() => {
    dispatch({
      type: "SET_BILLING_PAYLOAD",
      payload: {
        ...billingPayload,
        shopId: shopId,
        billId: uuid(),
        billingDate: new Date().toISOString().substring(0, 10),
        items: state.addedProducts,
        billVersion: 1,
        productTotal: getTotalAmount(),
        subTotal: getSubTotal(),
        taxList: taxList,
        billAmountDue: getTotalAmount(),
        otherCharges: billLineSettings.otherChargesField,
        invoiceNumber: `${billLineSettings.invoicePrefixField}${billLineSettings?.currentInvoiceNumber}`,
        invoicePrefix: billLineSettings.invoicePrefixField,
        orderType: state.orderType,
        couponDiscountAmount: getCouponValue(),
        customerDetailsEnabled: !billLineSettings.hasCustomerDetails,
      },
    });
  }, [
    state.orderType,
    state.addedProducts,
    getDiscountValue,
    getTotalAmount,
    billLineSettings?.currentInvoiceNumber,
    getSubTotal,
    taxList,
    shopId,
    getCouponValue,
    billLineSettings.hasCustomerDetails,
  ]);

  React.useEffect(() => {
    const fetchTaxsList = async (shopId) => {
      var res = await fetch(`${config.newApiGateway}/taxMaster/taxMaster`, {
        method: "POST",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          action: "fetchTaxmaster",
          shopId: shopId,
        }),
      });
      res = await res.json();
      if (res.code === "ERROR") {
        return alert(res.message);
      }
      setTaxList(res.data);
      dispatch({
        type: "SET_TAX_LIST",
        payload: res.data,
      });
    };
    if (shopId) {
      fetchTaxsList(shopId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopId]);

  return (
    <Billingcontext.Provider value={value} {...props}>
      {children}
    </Billingcontext.Provider>
  );
};

export default KOTBillingProvider;

export const useBilling = () => {
  const context = React.useContext(Billingcontext);
  if (context === undefined) {
    throw new Error(`useBilling must be used within a BillingProvider`);
  }
  return context;
};
